export default "__VITE_ASSET__ByzfVKal__"